import useForm from './useForm';
import TextField from 'components/TextField';
import styles from './blogs.module.scss';
import Button from 'components/Button';
import {Controller} from 'react-hook-form';
import Spinner from 'components/Spinner';
import {useState} from 'react';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import api from 'api';
import {useHistory} from 'react-router-dom';
import toast from 'react-hot-toast';
import {get} from 'lodash';
import {TemplateStatus} from '../TemplateList/useTemplate';
import cx from 'classnames';
import 'components/CkeditorTemplate/style.scss';

function TemplateDetails() {
  const {goBack} = useHistory();
  const {data, loading, control, errors, createHandler} = useForm();
  const [deleteVisible, setDeleteVisible] = useState(false);

  const deleteHandler = async () => {
    if (!data) return;
    try {
      await api.delete(`/support/blogs/${data.slug}`);
      setDeleteVisible(false);
      goBack();
    } catch (error) {
      toast.error(get(error, 'response.data.message', 'Failed to delete blog'));
    }
  };

  if (!data)
    return (
      <div className={styles.loader}>
        <Spinner />
      </div>
    );

  return (
    <>
      <div className={styles.status}>
        <Typography style={{marginBottom: 4, fontSize: 16}} variant="p">
          Published:
        </Typography>
        <TemplateStatus id={data.slug} active={data.is_active} />
      </div>
      <div className={styles.container}>
        <div className={styles.left}>
          <Controller
            control={control}
            name="title"
            rules={{required: 'Required'}}
            render={({field}) => (
              <TextField
                label="Title"
                placeholder="Title"
                value={field.value}
                wrapperClass={styles.title}
                onChange={field.onChange}
                error={errors.title?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="content"
            rules={{required: 'Required'}}
            render={({field}) => (
              <div
                className={cx(
                  'field-container ant-row ant-form-item',
                  styles.textareaWrapper
                )}
              >
                <div className={'ant-label'}>Content:</div>
                <textarea
                  className={styles.messageTextarea}
                  placeholder="Message"
                  value={field.value}
                  onChange={field.onChange}
                />
              </div>
            )}
          />
          <div
            style={{
              display: 'flex',
              gap: 12,
              marginTop: 20,
              justifyContent: 'flex-end',
            }}
          >
            <Button onClick={() => setDeleteVisible(true)} color="danger">
              Delete Template
            </Button>
            <Button loading={loading} onClick={createHandler} color="blue">
              Update Template
            </Button>
          </div>
        </div>
      </div>
      <Modal
        className={styles.modal}
        isOpen={deleteVisible}
        onRequestClose={() => setDeleteVisible(false)}
        onClose={() => setDeleteVisible(false)}
      >
        <Typography variant="h2">
          Are you sure you want to delete this template?
        </Typography>
        <Typography className={styles.deleteText} variant="p">
          This action is irreversible and will permanently delete the template.
        </Typography>
        <Button
          className={styles.deleteButton}
          onClick={deleteHandler}
          color="danger"
        >
          Delete
        </Button>
      </Modal>
    </>
  );
}

export default TemplateDetails;
